module.exports = __webpack_public_path__ + "static/img/moneyroad_green.ccf3f5f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/images/logo/moneyroad_green.svg
// module id = 301
// module chunks = 2